module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/press-desktop-9e6e308c5a07910c14088966ed1cc95d.webp";